export type IRemoveEntryViaAjax = (button: IjQueryElmOrHtmlElm) => void;

export function _removeEntryViaAjax(button: IjQueryElmOrHtmlElm): void {
  const $button = $(button);
  const $mainFieldSubFormHolder = $button.closest('.fieldSubForm');
  const json = JSON.parse(decodeURIComponent($button.data('json')));
  const {
    confirmMessage,
    removeUrl,
    successTitle,
    wrapperElm,
    successMessage,
    subFormId,
    subFormFieldId,
  } = json;
  const $wrapperElm = $button.closest(wrapperElm) as IjQueryElm;
  const confirm = window.confirm(confirmMessage);
  function callbackFn() {
    $wrapperElm.remove();
  }

  if (confirm) {
    window.DexeroCoreApp.blockUI($wrapperElm);
    $.get(removeUrl).done((responseData) => {
      if (responseData.success === 'true') {
        window.DexeroCoreApp.userToastMsg('success', successTitle, successMessage);
        window.DexeroCoreApp.highlightElm($wrapperElm, callbackFn);
        // Publish subform id change
        window.DexeroCoreApp.publish('/subform/updated', {
          mainFieldSubFormHolder: $mainFieldSubFormHolder,
          subFormFieldId,
          subFormId,
        });
      }
    });
  } else {
    $button.focus();
  }
}
